import React, { useState } from 'react';

const useCaseData = [
  {
    category: 'At Home for Family',
    primaryUsage: 'Private Space',
    scenarios: [
      { specificScenario: 'Temporary Private Room', example: 'Create a quiet space for working, reading, or meditating.' },
      { specificScenario: 'Dining Nook', example: 'Set up as a cozy enclosed dining area for intimate family meals.' },
      { specificScenario: 'Storage Room', example: 'Convert it into a secure, weatherproof storage unit for seasonal items.' },
      { specificScenario: 'Hobby Zone', example: 'Use it as a dedicated space for crafts, music practice, or workouts.' },
    ],
  },
  {
    category: 'At Home for Children',
    primaryUsage: 'Learning & Fun',
    scenarios: [
      { specificScenario: 'Study Corner', example: 'A distraction-free study space equipped with a desk and chair.' },
      { specificScenario: 'Playroom', example: 'A fun, safe environment for children to play with toys and games.' },
      { specificScenario: 'Sleepover Tent', example: 'Set up for children\'s sleepovers, offering a fun and private experience.' },
      { specificScenario: 'Privacy Pod', example: 'For older kids or teenagers to have their personal zone.' },
    ],
  },
  {
    category: 'At Home for Guests',
    primaryUsage: 'Hospitality',
    scenarios: [
      { specificScenario: 'Temporary Guest Room', example: 'Provide a private and comfortable sleeping area for guests.' },
      { specificScenario: 'Changing Room', example: 'Offer a compact yet private space for guests to change clothes.' },
      { specificScenario: 'Tea Lounge', example: 'Use as a temporary tea or coffee lounge when entertaining guests.' },
    ],
  },
  {
    category: 'At Home for Couples',
    primaryUsage: 'Romantic & Functional',
    scenarios: [
      { specificScenario: 'Intimate Retreat', example: 'A romantic space for couples to unwind with candles or dim lights.' },
      { specificScenario: 'Home Theater', example: 'Transform into a mini-theater for movie nights.' },
      { specificScenario: 'Personal Gym', example: 'Set up as a fitness room with basic equipment.' },
    ],
  },
  {
    category: 'In Office',
    primaryUsage: 'Productivity',
    scenarios: [
      { specificScenario: 'Meeting Pod', example: 'For private discussions or small team meetings.' },
      { specificScenario: 'Phone Booth', example: 'For employees needing privacy during calls or video meetings.' },
      { specificScenario: 'Relaxation Zone', example: 'Create a compact resting area for quick breaks or naps.' },
      { specificScenario: 'Workspace Partition', example: 'As a temporary divider for creating flexible workspaces.' },
    ],
  },
  {
    category: 'In Hotels',
    primaryUsage: 'Hospitality Enhancements',
    scenarios: [
      { specificScenario: 'Private Cabana', example: 'For outdoor or poolside privacy.' },
      { specificScenario: 'Event Booth', example: 'Temporary booths for exhibitions or small events within the hotel.' },
      { specificScenario: 'Staff Rest Area', example: 'A dedicated space for hotel staff to rest during shifts.' },
      { specificScenario: 'Overbooked Accommodation', example: 'As emergency lodging for overbooked scenarios.' },
      { specificScenario: 'Room in Room', example: 'Separate room within room for young children & parents at bedtime.' },
      { specificScenario: 'On Demand Bar Enclosure', example: 'Portable bar setup for special events or occasions.' },
      { specificScenario: 'On Demand Family Dining Enclosure', example: 'Temporary private dining spaces for families.' },
    ],
  },
  {
    category: 'Camping',
    primaryUsage: 'Outdoor Living',
    scenarios: [
      { specificScenario: 'Personal Tent', example: 'A weatherproof and customizable shelter or resting space.' },
      { specificScenario: 'Storage Room', example: 'Keep camping gear safe and dry.' },
      { specificScenario: 'Cooking Enclosure', example: 'A shielded area for cooking in windy or rainy conditions.' },
    ],
  },
  {
    category: 'Picnic',
    primaryUsage: 'Outdoor Leisure',
    scenarios: [
      { specificScenario: 'Shade Shelter', example: 'Protection from the sun or rain during picnics.' },
      { specificScenario: 'Dining Area', example: 'An enclosed space to eat without insects or debris.' },
      { specificScenario: 'Changing Room', example: 'For swapping into swimwear or clean clothes.' },
    ],
  },
  {
    "category": "Fair",
    "primaryUsage": "Exhibition and Sales",
    "scenarios": [
      { "specificScenario": "Vendor Booth", "example": "A flexible, portable booth for selling products or services." },
      { "specificScenario": "Information Kiosk", "example": "Use as an information center or help desk." },
      { "specificScenario": "Exhibition Space", "example": "Showcase products or art within the fairground." }
    ]
  },
  {
    "category": "Marriage",
    "primaryUsage": "Event Support",
    "scenarios": [
      { "specificScenario": "Bridal Room", "example": "A temporary makeup and dressing room for the bride." },
      { "specificScenario": "Green Room", "example": "For performers or VIPs to prepare." },
      { "specificScenario": "Kids’ Zone", "example": "A separate play area for children during the event." },
      { "specificScenario": "Sleeping Pod", "example": "A sleeping pod for guests providing privacy, especially for ladies or couples." },
      { "specificScenario": "Storage Room", "example": "Secure gifts or valuables during the event." }
    ]
  },
  {
    "category": "Long Distance Drivers",
    "primaryUsage": "Roadside Support",
    "scenarios": [
      { "specificScenario": "Rest Pod", "example": "A private space for truckers and drivers to sleep or relax." },
      { "specificScenario": "Emergency Shelter", "example": "Protection during bad weather conditions on the road." },
      { "specificScenario": "Mobile Office", "example": "Equipped with a desk for managing trip documentation." }
    ]
  },
  {
    "category": "Playground",
    "primaryUsage": "Outdoor Support",
    "scenarios": [
      { "specificScenario": "First Aid Station", "example": "A compact first-aid center for injuries or emergencies." },
      { "specificScenario": "Changing Room", "example": "For athletes or children to change clothes." },
      { "specificScenario": "Shaded Rest Area", "example": "For parents or children to rest between activities." },
      { "specificScenario": "Shaded Store Room", "example": "For players, officials, etc." }
    ]
  },
  {
    "category": "Night Shelter",
    "primaryUsage": "Emergency Housing",
    "scenarios": [
      { "specificScenario": "Homeless Shelter", "example": "Temporary housing for homeless individuals." },
      { "specificScenario": "Disaster Relief Shelter", "example": "Quick setup for people displaced due to natural calamities." },
      { "specificScenario": "Public Facility", "example": "Create temporary shelter in bus stands, railway stations, or parks." }
    ]
  },
  {
    "category": "Agriculture or Farming",
    "primaryUsage": "Field Support",
    "scenarios": [
      { "specificScenario": "Shedding for Crops", "example": "Protect agricultural yield from drizzle or rain on-field." },
      { "specificScenario": "Outdoor Equipment Storage", "example": "Secure farming tools and machinery from weather elements and theft." },
      { "specificScenario": "Temporary Seed and Fertilizer Storage", "example": "Safely store seeds and fertilizers in the field." },
      { "specificScenario": "Rest Room", "example": "On-field rest space for farmers and workers." },
      { "specificScenario": "Vertical Farming", "example": "Low-cost solution for multi-crop farming in rural or urban areas." }
    ]
  },
  {
    "category": "Roadside Vendors",
    "primaryUsage": "Vendor Support",
    "scenarios": [
      { "specificScenario": "Stall", "example": "Portable stalls offering privacy and protection from the elements." },
      { "specificScenario": "Storage", "example": "Temporary goods storage for perishable or non-perishable items." }
    ]
  },
  {
    "category": "Army",
    "primaryUsage": "Field Operations",
    "scenarios": [
      { "specificScenario": "Field Command Post", "example": "Portable center for operational planning and communication." },
      { "specificScenario": "Temporary Barracks", "example": "Accommodation for soldiers during operations." },
      { "specificScenario": "Medical Aid Station", "example": "A mobile unit for first aid or triage in combat zones." },
      { "specificScenario": "Equipment Storage and Maintenance", "example": "Secure storage for weapons and tools." },
      { "specificScenario": "Observation or Surveillance Post", "example": "Camouflaged shelter for monitoring activities." }
    ]
  },
  {
    "category": "Others",
    "primaryUsage": "Miscellaneous Uses",
    "scenarios": [
      { "specificScenario": "Selfie Cubes", "example": "Outdoor engagement cubes for fun at events." },
      { "specificScenario": "Public Restroom Enclosure", "example": "Temporary privacy enclosure for public restrooms." },
      { "specificScenario": "Photo Room", "example": "Outdoor photo dark room for private photo shoots." },
      { "specificScenario": "Outdoor Community Bathroom", "example": "Privacy enclosure for community bathrooms during gatherings." },
      { "specificScenario": "Decoration Cube", "example": "Used for display, prayers, or presentations." }
    ]
  },
  {
    "category": "Key Features for All Scenarios",
    "primaryUsage": "Universal Applications",
    "scenarios": [
      { "specificScenario": "Portability", "example": "Easy to transport and assemble in minutes." },
      { "specificScenario": "Adjustability", "example": "Customizable sizes ranging from 4x4x4 ft to 10x10x10 ft." },
      { "specificScenario": "Durability", "example": "Weather-resistant materials suitable for various environments." },
      { "specificScenario": "Multi-functionality", "example": "Adaptable for residential, commercial, and recreational purposes." }
    ]
  }
];

const RoomAnywhereUseCases = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (category) => {
    setExpandedSections((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <div className="room-anywhere-use-cases p-4">
      <h1 className="text-xl text-yellow-200 font-bold mb-4">RoomAnywhere Real-World Applications / Use Cases</h1>
      {useCaseData.map((useCase, index) => (
        <div key={index} className="section mb-4">
          <button
            onClick={() => toggleSection(useCase.category)}
            className="w-full text-left bg-blue-500 text-white px-4 py-2 rounded"
          >
            {useCase.category} {expandedSections[useCase.category] ? '▲' : '▼'}
          </button>
          {expandedSections[useCase.category] && (
            <div className="content mt-2 p-4 border text-white border-blue-500 rounded">
              <h2 className="text-lg text-yellow-200 font-semibold">{useCase.primaryUsage}</h2>
              <ul className="list-disc list-inside">
                {useCase.scenarios.map((scenario, scenarioIndex) => (
                  <li key={scenarioIndex}>
                    <strong >{scenario.specificScenario}:</strong> {scenario.example}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RoomAnywhereUseCases;
